import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

export interface UpdateTaxRateRequest {
  id: number;
  name: string;
  tax: number;
}

export type UpdateTaxRateResponse = BaseResponse<null>;

async function updateTaxRate(
  data: UpdateTaxRateRequest
): Promise<UpdateTaxRateResponse> {
  try {
    return (await axiosInstance.put("/Product/UpdateTaxRate", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useUpdateTaxRate() {
  return useMutation<UpdateTaxRateResponse, Error, UpdateTaxRateRequest>(
    (variables) => updateTaxRate(variables)
  );
}